import styled from "styled-components";


export const SmartfocusContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 10px;
  margin: 0px 0px 0px 17px !important;
  padding: 16px 2px !important;
  @media screen and (max-width: 767px), screen and (max-device-width: 767px) {
    padding: 16px 29px !important
  }
  .effectTitle {
    padding: 16px 0px 2px !important;
  }
  &.transitionPanel{
    margin: 0px !important
  }
`;

export const AddSmartfocusContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 24px;
  padding: 83px 34px 34px 34px;
  .addzoom-btn {
     position: relative;
     label {
       padding-left: 35px;
     }
  }
  @media (max-height: 767px) {
      padding: 50px 20px;
  }
`;

export const CursorContainer = styled.div`
   display: flex;
   width: 316px;
   padding: 12px;
   flex-direction: column;
   gap: 4px;
   border-radius: 12px;
   border: 1px solid #E3E4E8;
   background: #FFF;
   box-shadow: 0 0.5px 1px 0 rgba(0, 0, 0, 0.16);
   overflow: hidden;
`;

export const TitleContainer = styled.div` 
   display: flex;
   justify-content: space-between;
   align-items: center;
`;

export const CursorTitleContainer = styled.div`
   display: flex;
   justify-content: space-between;
   align-items: center;
   width: 100%;
   gap: 10px;
`;

export const SfWorkspaceContainer = styled.div`
   width: 292px;
   height: 190px;
   border-radius: 8px;
   background: #ffffff
   position: relative;
`;

export const SfWorkspaceWrapper = styled.div`
   position: relative;
   &:after {
   position: absolute;
   top: 0;
   left: 0;
   content: '';
   width: 292px;
   height: 190px;
   border-radius: 0px;
   background: rgba(0, 0, 0, 0.5);
   z-index: 5; 
   pointer-events: none;
  }
`;

export const SfScaleContainer = styled.div`
   width: 292px;
   display: flex;
   justify-content: center;
   align-items: center;
   padding: 0px 12px;
   margin-top: 10px;
   display: flex;
   flex-direction: column;
   gap: 12px;
`;


export const ScaleHeader = styled.div`
   display: flex;
   justify-content: space-between;
   align-items: center;
   width: 316px;
   margin: 0px 0px 0px 17px !important;
`;

export const ScaleInputWrapper = styled.div`

   width: 70px;
   height: 36px;
   box-sizing: border-box;
   border: 1px solid ${(props) => props.theme.primaryBorderColor};
   border-radius: 6px;
   padding-left: 5px;
   ${(props) => props.customInputStyle}
   &:hover {
     ${(props) => props.hoverEffects}
   }
   &:focus {
     ${(props) => props.activeEffects}
   }
`;

export const IndexContainer = styled.div`
  width: 333px;
  display: flex;
  flex-direction: column;

  /* Works reliably on iOS */
  @media screen and (max-width: 767px), screen and (max-device-width: 767px) {
    width: 100%;
  }
`;

export const SearchInput = styled.input`
   width: 62px;
   height: 36px;
   box-sizing: border-box;
   border: 1px solid ${(props) => props.theme.primaryBorderColor};
   border-radius: 6px;
   padding-left: 5px;
   padding-right: 5px;
   ${(props) => props.customInputStyle}
   &:hover {
      ${(props) => props.hoverEffects}
   }
   &:focus {
      ${(props) => props.activeEffects}
   }
`;

export const SearchInputContainer = styled.div`
   position: relative;
`;

export const SpaceUnavailableWrapper = styled.div`
   display: flex;
   flex-direction: column;
   align-items: center;
   justify-content: center;
   gap: 12px;
   padding: 7px;
`;

export const TextContainer = styled.div`
   display: flex;
   flex-direction: column;
   align-items: start;
   justify-content: center;
   gap: 33px;
`;

export const BackgroundCircle = styled.div`
   width: 45px;
   height: 45px;
   border-radius: 50%;
   background: #FFDEDE;
   display: flex;
   padding: 8px;
   justify-content: center;
   align-items: center;
`;

export const TextContainerCenter = styled.div`
   display: flex;
   flex-direction: column;
   align-items: center;
   justify-content: center;
   gap: 12px;
   padding: 24px;
`;


export const Overlay = styled.div`
  position: absolute;
  background: rgba(0, 0, 0, 0.5);
  top: ${(props) => props.top}px;
  left: ${(props) => props.left}px;
  width: ${(props) => props.width}px;
  height: ${(props) => props.height}px;
  border-bottom-right-radius:  ${(props) => props.br}px;
  border-bottom-left-radius:  ${(props) => props.bl}px;
  border-top-right-radius:  ${(props) => props.tr}px;
  border-top-left-radius:  ${(props) => props.tl}px;
  z-index: 10;
  -webkit-backface-visibility: hidden;
  -webkit-transform: translateZ(0) scale(1.0, 1.0);
  transform: translateZ(0);
  overflow: hidden;
`;

export const MaskArea = styled.div`
  position: absolute;
  width: 292px;
  height: 170px;
  cursor: grab;
  z-index: 11;
  -webkit-backface-visibility: hidden;
  -webkit-transform: translateZ(0) scale(1.0, 1.0);
   @media (max-width: 767px) {
     pointer-events: none;
  }
`;

export const CenterCircle = styled.div`
  position: absolute;
  width: 30px;
  height: 30px;
  background-color: black;
  border-radius: 50%;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  pointer-events: none;
  z-index: 12;
  display: flex;
  justify-content: center;
  align-items: center;
`;

export const OverlayContainer = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  width: 292px;
  height: 190px;
`;
